import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'aumico-upload-organization-pdf-template',
    templateUrl: './upload-organization-pdf-template.component.html',
    styleUrls: ['./upload-organization-pdf-template.component.scss'],
})
export class UploadOrganizationPdfTemplateComponent {
    public uploadedFile: File | null = null;
    private formData: FormData = new FormData();

    // Properties to determine file type and UI text
    public get isExcelUpload(): boolean {
        return this.data?.isExcel === true;
    }

    public get acceptedFileTypes(): string {
        return this.isExcelUpload ? '.xlsx,.xls' : '.docx,.pdf';
    }

    public get uploadLabel(): string {
        return this.isExcelUpload 
            ? 'Upload Excel Template' 
            : 'Upload PDF Template';
    }

    public get fileTypeErrorKey(): string {
        return this.isExcelUpload
            ? 'Only Excel files (.xlsx, .xls) are allowed'
            : 'Only Word/PDF files (.docx, .pdf) are allowed';
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        private matDialogRef: MatDialogRef<UploadOrganizationPdfTemplateComponent>,
    ) {}

    public onFileUploadedChanged(event: File): void {
        this.uploadedFile = event;
        if (this.uploadedFile != null) {
            this.formData.append('file', this.uploadedFile, this.uploadedFile.name);
        }
    }

    public applyActionAndClose(): void {
        this.data.action(this.formData);
        this.closeDialog();
    }

    public closeDialog(): void {
        this.matDialogRef.close();
    }
}
